module.exports = __webpack_public_path__ + "static/media/hero-img.33a52d09.jpg";